import React from 'react';
import CareerHero from './Career';
import WhyJoinUs from './WhyJoin';
import JobOpenings from './JobOpening';
import CTASection from './CTASection';
// import './App.css';

const MainCareer = () => {
  return (
    <div className="main-content">
      <CareerHero />
      <WhyJoinUs />
      <JobOpenings />

      <CTASection />
    </div>
  );
}

export default MainCareer;